import SpacerChild, { SpacerChildProps } from './SpacerChild';

export default SpacerChild;
export type { SpacerChildProps };
